/**
 * DADDL featured tabs — centered pack carousel (same math as video trust).
 * Viewport clips the track; neighbours peek at both edges.
 * Loop engine: window.daddlBindCenteredLoop in daddl-carousel.js.
 * Do not use Swiper or <daddl-carousel> here.
 */
(function () {
  'use strict';

  function stripCloneControls(slide) {
    slide.querySelectorAll('form').forEach(function (form) {
      form.setAttribute('aria-hidden', 'true');
      form.querySelectorAll('button, input, select, textarea').forEach(function (ctrl) {
        ctrl.disabled = true;
      });
    });
  }

  function bindPanel(panel) {
    if (panel.daddlFtBound) return;
    if (typeof window.daddlBindCenteredLoop !== 'function') {
      document.addEventListener('DOMContentLoaded', function () { bindPanel(panel); });
      return;
    }

    var viewport = panel.querySelector('[data-daddl-ft-viewport]');
    var track = panel.querySelector('[data-daddl-ft-track]');
    var prevBtn = panel.querySelector('[data-daddl-ft-prev]');
    var nextBtn = panel.querySelector('[data-daddl-ft-next]');
    if (!viewport || !track) return;

    panel.daddlFtBound = true;

    var loopCtl = window.daddlBindCenteredLoop({
      viewport: viewport,
      track: track,
      prev: prevBtn,
      next: nextBtn,
      slideSelector: '[data-daddl-ft-slide]',
      cloneAttr: 'data-daddl-ft-clone',
      instantClass: 'is-instant',
      ignoreDown: 'button',
      prepareClone: stripCloneControls,
      onActive: function (index, slides) {
        slides.forEach(function (el, i) {
          el.classList.toggle('is-active', i === index);
        });
      }
    });

    panel.daddlFtPosition = function (animate) {
      if (loopCtl) loopCtl.position(!!animate);
    };
  }

  class DaddlFeaturedTabs extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.tabs = this.querySelectorAll('[data-daddl-ft-tab]');
      this.panels = this.querySelectorAll('[data-daddl-ft-panel]');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab));
      });

      this.panels.forEach((panel) => {
        if (!panel.hidden) bindPanel(panel);
      });
    }

    activate(tab) {
      const id = tab.getAttribute('data-daddl-ft-tab');
      this.tabs.forEach((item) => {
        const on = item === tab;
        item.classList.toggle('is-active', on);
        item.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.panels.forEach((panel) => {
        const show = panel.getAttribute('data-daddl-ft-panel') === id;
        panel.hidden = !show;
        if (show) {
          bindPanel(panel);
          if (typeof panel.daddlFtPosition === 'function') panel.daddlFtPosition(false);
        }
      });
    }
  }

  if (!customElements.get('daddl-featured-tabs')) {
    customElements.define('daddl-featured-tabs', DaddlFeaturedTabs);
  }
})();
